import CallRoundedIcon from '@mui/icons-material/CallRounded';
import MessageRoundedIcon from '@mui/icons-material/MessageRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded';
import ScheduleSendRoundedIcon from '@mui/icons-material/ScheduleSendRounded';
import PracticeDialog from '../../Pages/PracticesPage/Components/Dialog';
import AppointmentDialog from '../../Components/Dialog/AppointmentDialog';
import ManualActivityDialog from '../../Components/Dialog/ManualActivityDialog';
import AppointmentForm from '../../Pages/CustomerPage/CallSection/ResultBox/AppointmentForm';
import ManualActivityContent from '../../Components/Dialog/ManualActivityDialog/ManualActivityContent';
import RecallForm from '../../Pages/CustomerPage/CallSection/ResultBox/RecallForm';
import TouchAppRoundedIcon from '@mui/icons-material/TouchAppRounded';
import IncomingCallDialog from '../../Pages/CustomerPage/CallSection/InboundCallDialog';
import RecallDialog from '../../Components/Dialog/RecallDialog';

export const ACTIVITY_TYPES_COLORS = {
  CALL: '#34A853',
  EMAIL: '#b00020',
  SMS: '#1D5B9D',
  APPOINTMENT: '#b00020',
  DOSSIER: '#c6cbf0',
  'MASSIVE-SMS': '#0288d1',
  MANUAL: '#f9a825',
};

export const ACTIVITY_TYPES_ICONS = {
  CALL: CallRoundedIcon,
  EMAIL: EmailRoundedIcon,
  SMS: MessageRoundedIcon,
  APPOINTMENT: EventRoundedIcon,
  DOSSIER: InsertDriveFileRoundedIcon,
  'MASSIVE-SMS': ScheduleSendRoundedIcon,
  MANUAL: TouchAppRoundedIcon,
};

export const ACTIVITY_TYPES_DIALOGS = {
  CALL: IncomingCallDialog,
  APPOINTMENT: AppointmentDialog,
  DOSSIER: PracticeDialog,
  MANUAL: ManualActivityDialog,
  RECALL: RecallDialog,
};

export const ACTIVITY_TYPES_FORMS = {
  CALL: RecallForm,
  APPOINTMENT: AppointmentForm,
  DOSSIER: null,
  MANUAL: ManualActivityContent,
};
